import { useState } from "react"
import Window from "../Window/Window"
import styles from "./TrashWindow.module.css"
import { useSound } from "../../hooks/useSound"
import { SOUNDS } from "../../constants/sounds"
import CursedAlert from "./CursedAlert"

type Props = { 
  onClose: () => void
  isMinimized: boolean
  onToggleMinimize: () => void 
}

export default function TrashWindow({ onClose, isMinimized, onToggleMinimize }: Props) {
  const [showCursed, setShowCursed] = useState(false)
  const playClickFolder = useSound(SOUNDS.CLICK_FOLDER, { volume: 0.4 })

  const handleCursedClick = () => {
    playClickFolder()
    setShowCursed(true)
  }

  if (isMinimized) return null

  return (
    <>
      <Window
        title="Lixeira"
        onClose={onClose}
        isMinimized={isMinimized}
        onToggleMinimize={onToggleMinimize}
        initialPosition={{ x: 180, y: 80 }}
        initialSize={{ width: 600, height: 400 }}
        minSize={{ width: 400, height: 300 }}
        bodyClassName={styles.body}
      >
        <div className={styles.grid}>
          <button
            className={styles.file}
            onClick={handleCursedClick}
            aria-label="NAO_ABRA.exe"
            title="NAO_ABRA.exe"
          >
            <img src="/images/icons/file-doc.png" className={styles.fileIcon} alt="" />
            <span className={styles.fileLabel}>NAO_ABRA.exe</span>
          </button>
        </div>
      </Window>

      {showCursed && <CursedAlert onClose={() => setShowCursed(false)} />}
    </>
  )
}